import { flashStore } from '@/store';
import { getApiBaseUrl } from '@/utils/api';
import useCookie from './useCookie';

import i18n from '../i18n';

const { t } = i18n.global;

export const fetchCsrf = async () => {
    const csrfResponse = await fetch(`${getApiBaseUrl()}/sanctum/csrf-cookie`, { credentials: 'include' });

    if (!csrfResponse.ok) {
        flashStore.doFlash({ message: t('flash.serverProblem') });
    }
};

export function fetchHttp (uri: string, options: any = {}): Promise<Response> {
    const headers = new Headers();
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');

    const csrf = useCookie('XSRF-TOKEN');

    if (csrf) {
        headers.set('X-XSRF-TOKEN', csrf);
    }

    if (options.headers) {
        Object.entries(options.headers).forEach(([key, value]) => {
            headers.set(key, value as string);
        });
    }

    Object.assign(options, { credentials: 'include', headers });

    return fetch(`${getApiBaseUrl()}${uri}`, options);
}
